import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
import TextRotator from '../../utils/TextRotator';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  height: 100vh;
  padding: 0;

  @media (max-height: 700px) and (min-width: 700px), (max-width: 360px) {
    height: auto;
    padding-top: var(--nav-height);
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 5px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .heightLimited {
    overflow: hidden;
    max-height: clamp(40px, 8vw, 80px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  const [thing, setThing] = useState('');

  const callTextRotatorInSeries = async (things, setThing) => {
    let i = 0;
    while (i < things.length - 1) {
      await TextRotator(things[i], things[i + 1], setThing);
      i++;
      if (i === things.length - 1) {
        i = 0;
      }
    }
  };

  useEffect(() => {
    const thingsIam = ['parent', 'web developer', 'NZ citizen', 'tech realist', 'cat owner'];
    thingsIam.push(thingsIam[0]);
    callTextRotatorInSeries(thingsIam, setThing);
  }, [setThing]);

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, my name is</h1>;
  const two = <h2 className="big-heading">Jonathan Alpers.</h2>;
  const three = (
    <div className="heightLimited">
      <h3 className="big-heading">
        I'm a <span>{thing.trim()}</span>.
      </h3>
    </div>
  );
  const four = (
    <>
      <p>
        I am a full-stack web developer based in Aotearoa New Zealand, specialising in building and
        maintaining web applications, using open source technologies and open standards. Currently
        I’m working for Te Mahi Ako, an e-learning provider.
      </p>
    </>
  );

  const items = [one, two, three, four];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
